/**
 * App.js — top-level component for the iProtectYou.Family Quote &
 * Appointment app.
 *
 * Routes (skeleton — flows are built in the next phase):
 *   /                public landing placeholder
 *   /quote           quote-request flow      (CTA: "Get Your Free Quote")
 *   /book            appointment booking     (CTA: "Book An Appointment")
 *   /agent/login     agent sign in (Andy)
 *   /agent           agent dashboard (auth-guarded)
 *
 * The site-wide UnderConstructionBanner renders on public routes only
 * (controlled by the REACT_APP_UNDER_CONSTRUCTION build arg). It is hidden on
 * /agent* so the agent dashboard reads clean.
 */

import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import RequireAuth from './components/RequireAuth';
import UnderConstructionBanner from './UnderConstructionBanner';
import AgentDashboard from './pages/AgentDashboard';
import AgentLogin from './pages/AgentLogin';
import Appointment from './pages/Appointment';
import Landing from './pages/Landing';
import Quote from './pages/Quote';

export default function App() {
  // Public-only banner — keep the agent dashboard clean.
  const { pathname } = useLocation();
  const hideBanner = pathname.startsWith('/agent');

  return (
    <>
      {hideBanner ? null : <UnderConstructionBanner />}

      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/book" element={<Appointment />} />
        <Route path="/agent/login" element={<AgentLogin />} />
        <Route
          path="/agent"
          element={
            <RequireAuth>
              <AgentDashboard />
            </RequireAuth>
          }
        />
      </Routes>
    </>
  );
}
